/* eslint-disable react/display-name */
import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputBase } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {
  backgroundColors,
  colorDanger,
  fontColors,
} from '../../material-ui-theme';

// Form value pickup
// component: 'text-input'
// value: value

const postFixComonStyles = {
  position: 'absolute',
  cursor: 'pointer',
  right: 0,
  display: 'flex',
  height: '100%',
  width: 40,
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'transparent',
  border: 'none',
  padding: 0,
  margin: 0,

  '&:focus': {
    outline: 'none',
  },

  '& .MuiSvgIcon-root': {
    fontSize: 18,
  },
};

const useStyles = makeStyles((theme) => ({
  inputRoot: {
    width: '100%',
    color: 'var(--color-fontColors-black)',
  },
  inputPaper: {
    padding: 0,
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: 'var(--color-bg-flat-grey)',
    borderRadius: 4,
    '& input': {
      padding: '6px 3px 6px 6px',
      margin: 0,
      fontSize: '0.9rem',
      fontWeight: 400,
      color: 'var(--color-fontColors-black)',
      border: '1px solid',
      borderRadius: 4,
      borderColor: 'transparent',
      height: 34,
      minWidth: 40,
      boxSizing: 'border-box',
    },

    '& .search-postfix': {
      ...postFixComonStyles,

      '& svg': {
        color: 'var(--color-fontColors-dark)',
      },
    },
  },
  inputPaperDisabled: {
    backgroundColor: backgroundColors.disabled,
    padding: 0,
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
    borderRadius: 4,
    '& input': {
      padding: '6px 3px 6px 6px',
      margin: 0,
      fontSize: '0.9rem',
      fontWeight: 400,
      color: fontColors.disabled,
      '-webkit-text-fill-color': fontColors.disabled,
      opacity: 1 /* required on iOS */,
      border: '1px solid',
      borderRadius: 4,
      borderColor: 'var(--color-backgroundColors-grey)',
      height: 34,
      minWidth: 40,
      boxSizing: 'border-box',
    },

    '& .search-postfix': {
      ...postFixComonStyles,

      '& svg': {
        color: 'var(--color-fontColors-dark)',
      },
    },
  },
  input: {
    flex: 1,
  },
  helperText: {
    margin: 0,
    fontSize: '0.9rem',
    marginTop: '3px',
    textAlign: 'left',
    fontWeight: 500,
    color: colorDanger.main,
    paddingLeft: theme.spacing(1),
  },
}));

const FlatSearchGrey = memo(
  ({
    label,
    onChange,
    error,
    helperText,
    disabled,
    inputProps = {},
    onSearch = () => {},
    onClear = () => {},
    onEsacpe = () => {},
    value = '',
    ...restProps
  }) => {
    const classes = useStyles();

    const handleOnSearch = (e) => {
      if (!e.key) {
        return;
      }

      if (e.key.toLowerCase() === 'enter') {
        onSearch(e.target.value);
      } else if (e.key.toLowerCase() === 'escape') {
        onEsacpe(e.target.value);
      }
    };

    return (
      <FormControl
        className={label ? classes.inputLabelRoot : classes.inputRoot}
        error={error}
      >
        <div
          className={
            disabled
              ? `${classes.inputPaperDisabled} inputPaperDisabled-class`
              : classes.inputPaper
          }
        >
          <InputBase
            onChange={(event) => onChange(event.target.value)}
            className={classes.input}
            disabled={disabled}
            inputProps={{
              ...inputProps,
              'data-component': 'text-input',
            }}
            onKeyDown={handleOnSearch}
            value={value}
            {...restProps}
          />
          {value ? (
            <button className="search-postfix" onClick={onClear} type="button">
              <CloseIcon />
            </button>
          ) : (
            ''
          )}
        </div>
        {error && helperText !== '' ? (
          <p className={classes.helperText}>{helperText}</p>
        ) : null}
      </FormControl>
    );
  }
);

export default FlatSearchGrey;
